import { render, staticRenderFns } from "./PreviewJobContentForSp.vue?vue&type=template&id=2d996710&scoped=true"
import script from "./PreviewJobContentForSp.vue?vue&type=script&lang=js"
export * from "./PreviewJobContentForSp.vue?vue&type=script&lang=js"
import style0 from "./PreviewJobContentForSp.vue?vue&type=style&index=0&id=2d996710&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d996710",
  null
  
)

export default component.exports